import { Insurance } from 'constants/routes';

import * as Constants from './constants';

const { ROUTE_NAMES } = Insurance;

export const INITIAL_DATA_STATE = Object.values(Constants.DATA_FIELDS).reduce((acc, key) => {
  acc[key] = { ...Constants.DEFAULT_DATA_VALUE };

  return acc;
}, {});

export const INITIAL_PAGES_STATE = {
  [ROUTE_NAMES.CREATE_NEW]: { ...Constants.DEFAULT_PAGES_VALUE },
  [ROUTE_NAMES.DRIVERS]: { ...Constants.DEFAULT_PAGES_VALUE },
  [ROUTE_NAMES.POLICYHOLDER]: { ...Constants.DEFAULT_PAGES_VALUE },
  [ROUTE_NAMES.VEHICLE_INFORMATION]: { ...Constants.DEFAULT_PAGES_VALUE },
};

export const INITIAL_STAGES_STATE = Object.values(Constants.STAGES_FIELDS).reduce((acc, key) => {
  acc[key] = { ...Constants.DEFAULT_STAGES_VALUE };

  return acc;
}, {});

export const INITIAL_STATE = {
  [Constants.FIELDS.DATA]: INITIAL_DATA_STATE,
  [Constants.FIELDS.PAGES]: INITIAL_PAGES_STATE,
  [Constants.FIELDS.STAGES]: INITIAL_STAGES_STATE,
};
